module.exports = __webpack_public_path__ + "img/H-B-4-unload-connect-shadow.6ff6f2f7.png";